import { IWholeNumberInputControlProps } from '../WholeNumberInputControl';
import React from 'react';
import { Stack } from 'react-bootstrap';
import classNames from 'classnames';

export function CurrencyWithCentsInputControl(props: IWholeNumberInputControlProps) {
    const allStyles = { width: '25%', maxWidth: '170px', ...props.style };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const regex = props.allowNegativeValues ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;

        if (regex.test(value) || value === '') {
            props.onChange(e);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const blockedKeys = props.allowNegativeValues
            ? ['e', 'E', '+', ',']
            : ['e', 'E', '+', '-', ','];

        if (blockedKeys.includes(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <Stack direction="horizontal" gap={1}>
            <span>$</span>
            <input
                type="text"
                inputMode="decimal"
                className={classNames('form-control d-inline-block', props.className)}
                disabled={props.disabled}
                name={props.name}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder={props.placeholder}
                style={allStyles}
                value={props.value ?? ''}
            />
        </Stack>
    );
}
